import Axios from 'axios';
import header from './header';

const API_URL = process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/auth';

class Authentication {
  getMe(){
    return Axios.get(API_URL_V3 + '/me', { headers: header() });
  }

  // Kode sekali pakai (berlaku 60 detik) untuk mengoper sesi ke dashboard baru.
  // Token asli tidak pernah keluar dari aplikasi ini.
  issueSsoHandoffCode() {
    return Axios.post(API_URL_V3 + '/sso/issue', null, { headers: header() });
  }

  login(data) {
    return Axios.post(API_URL_V3 + '/login', data)
      .then(res => {
        if (res.data.meta.code == 200) {
          const userData = {
            info: res.data.data.user,
            token: res.data.data.api_token
          };
  
          localStorage.setItem('user', JSON.stringify(userData));
          return userData;
        } else {
          return Promise.reject(res.data.meta.message || 'Login gagal');
        }
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  register(data) {
    return Axios.post(API_URL_V3 + '/register', {
      email: data.email,
      name: data.name,
      role_id: data.role_id,
      alamat: data.alamat,
      phone: data.phone,
      npwp: data.npwp,
      password: data.password,
      password_confirmation: data.password,
      token: data.token,
      referral_code: data.referral_code || null
    })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err)
    })
  }

  registerMitra(data) {
    return Axios.post(API_URL + 'add-mitracontact', {
      name: data.name,
      nama_organisasi_perusahaan: data.nama_organisasi_perusahaan,
      alamat: data.alamat,
      email: data.email,
      no_telpon: data.no_telpon,
      npwp: data.npwp,
      jenismitra_id: data.jenismitra_id,
      token: data.token
    })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.log(err)
    })
  }

  logout() {
    // Sesi lokal wajib dibersihkan apa pun hasil pemanggilan API. Kalau tidak, token
    // yang sudah tidak berlaku (misal karena di-logout paksa dari sisi admin) membuat
    // API menjawab 401, pembersihan tidak pernah jalan, dan aplikasi tetap menganggap
    // user masih login.
    const clearSession = () => {
      localStorage.removeItem('user');
      localStorage.removeItem('selectedTab');
    };

    return Axios.post(API_URL + 'logout-user', null, { headers: header() })
      .then(clearSession, clearSession);
  }
}

export default new Authentication();



// WEBPACK FOOTER //
// ./src/api/auth/authentication.js